<script setup>
import { computed, onMounted } from 'vue'
import { useProductListStore } from '@/store'
import Card from './ModuleCard.vue'
import Pagination from './ModulePagination.vue'
import { loadLanguageAsync } from '@/plugins/i18n'
import { gsap } from 'gsap'

// Initialize the store
const store = useProductListStore()

// Computed properties and state
const items = computed(() => store.items)
const loaded = computed(() => store.loaded)
const comparelisturl = computed(() => store.comparelisturl)
const openPopup = computed({
  get: () => store.showPopup,
  set: (payload) => store.updateShowPopup(payload),
})

// Methods
const scrollTop = () => {
  const el = document.querySelector('.product__list')
  const domRect = el.getBoundingClientRect()
  const scrollingElement = document.scrollingElement || document.documentElement
  gsap.to(window, { duration: 0.5, scrollTo: { y: domRect.top + scrollingElement.scrollTop - 100, autoKill: false } })
}

// Lifecycle hooks
onMounted(() => {
  loadLanguageAsync().then(() => {
    store.setPredefinedFilter()
    store.get().then(() => {
      store.handleSyliusCall()
    })
  })
})
</script>

<template>
  <div class="list__list">
    <div class="product__list">
      <div class="list__list" v-if="loaded">
        <Card v-for="(item, idx) in items" :key="idx" :item="item" />
        <div class="card__card--placeholder"></div>
      </div>
      <div class="list__list" v-else>
        <template v-for="n in 9" :key="n">
          <div class="card__item card__item--loading">
            <div class="item__image"></div>
            <div class="item__content">
              <div class="content__headline"><span></span><span></span></div>
              <div class="content__meta"><span></span></div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <Pagination @scrollTop="scrollTop" />
    <div class="module-comparelist-popup" v-if="openPopup" @mousedown="openPopup = false">
      <div class="popup__content">
        <div class="close-icon icon-times-before"></div>
        <p>{{ $t('list.popup.text') }}</p>
        <a :href="comparelisturl" target="_blank" @mousedown.stop>{{ $t('list.popup.btn') }}</a>
      </div>
    </div>
  </div>
</template>
